import React from 'react';

export default function Link({ text, href }) {
	if (href.indexOf('http') > -1)
		return (
			<a
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				className="no-underline hover:underline text-blue-500"
			>
				{text}
			</a>
		);
	else
		return (
			<a href={href} className="no-underline hover:underline text-blue-500">
				{text}
			</a>
		);
}
